export enum Locale {
  au = 'en-AU',
  us = 'en-US',
  uk = 'en-GB',
  ca = 'en-CA',
  nz = 'en-NZ',
  za = 'en-ZA',
}

export function isLocaleType(
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  maybeLocale: unknown | Locale,
): maybeLocale is Locale {
  return Object.keys(Locale).includes(maybeLocale as Locale)
}

export const siteLocale: Locale = (process.env['NEXT_PUBLIC_LOCALE'] ??
  Locale.au) as Locale

export const localeToTld = new Map<Locale, string>()
localeToTld.set(Locale.au, '.com.au')
localeToTld.set(Locale.us, '.com')
localeToTld.set(Locale.ca, '.ca')
localeToTld.set(Locale.uk, '.co.uk')
localeToTld.set(Locale.nz, '.co.nz')
localeToTld.set(Locale.za, '.co.za')

export function replaceTldForLocale(domain: string, locale: Locale): URL {
  const url = new URL(`https://${domain}`)
  const { hostname } = url
  const hostnameWithNewTLD = hostname.replace(
    /(?:\.com.au|\.com|\.ca|\.co.uk|\.co.nz|\.co.za)$/,
    localeToTld.get(locale) ?? '.com.au',
  )
  url.hostname = hostnameWithNewTLD
  return url
}
